import { Component, OnInit, Input } from '@angular/core';
import { OperatorFront } from '../../../../models/api.models';

@Component({
  selector: 'app-operario-chip',
  templateUrl: './operario-chip.component.html',
  styleUrls: ['./operario-chip.component.scss'],
})
export class OperarioChipComponent implements OnInit {

  @Input() operator: OperatorFront = new OperatorFront();

  constructor() { }

  ngOnInit() {}

}
